import { Descriptions, Empty } from 'antd'
import dayjs from 'dayjs'
import { IOutlet, OUTLET_SEGMENT_OPTIONS, OUTLET_TYPE_OPTIONS } from '../../models/outlet.modal'

const fmtDate = (v?: string | null) => {
    if (!v) return '—'
    const d = dayjs(v)
    if (!d.isValid() || d.year() < 2000) return '—'
    return d.format('DD/MM/YYYY')
}

const fmtDateTime = (v?: string | null) => {
    if (!v) return '—'
    const d = dayjs(v)
    if (!d.isValid() || d.year() < 2000) return '—'
    return d.format('DD/MM/YYYY HH:mm')
}

const labelFrom = (opts: { value: string, label: string }[], v?: string) => {
    if (!v) return '—'
    return opts.find(o => o.value === v)?.label ?? v
}

export default function TabInfo({ outlet }: { outlet: IOutlet | null }) {
    if (!outlet) {
        return <Empty description='Không tìm thấy đại lý' />
    }

    return (
        <Descriptions bordered column={2} size='middle'>
            <Descriptions.Item label='ID'>{outlet.id || '—'}</Descriptions.Item>
            <Descriptions.Item label='Mã'>{outlet.code || '—'}</Descriptions.Item>
            <Descriptions.Item label='Tên'>{outlet.name || '—'}</Descriptions.Item>
            <Descriptions.Item label='Công ty (cpCode)'>{outlet.cpCode || '—'}</Descriptions.Item>
            <Descriptions.Item label='Số điện thoại'>{outlet.phone || '—'}</Descriptions.Item>
            <Descriptions.Item label='Nhân sự phụ trách'>
                {outlet.ownerUserName || (outlet.ownerUserId ? `#${outlet.ownerUserId}` : '—')}
            </Descriptions.Item>
            <Descriptions.Item label='Loại'>{labelFrom(OUTLET_TYPE_OPTIONS, outlet.outletType)}</Descriptions.Item>
            <Descriptions.Item label='Phân khúc'>{labelFrom(OUTLET_SEGMENT_OPTIONS, outlet.segment)}</Descriptions.Item>
            <Descriptions.Item label='Vùng'>{outlet.region || '—'}</Descriptions.Item>
            <Descriptions.Item label='Tỉnh/TP'>{outlet.province || '—'}</Descriptions.Item>
            <Descriptions.Item label='Quận/Huyện'>{outlet.district || '—'}</Descriptions.Item>
            <Descriptions.Item label='Phường/Xã'>{outlet.ward || '—'}</Descriptions.Item>
            <Descriptions.Item label='Địa chỉ' span={2}>{outlet.address || '—'}</Descriptions.Item>
            <Descriptions.Item label='Sản lượng SIM/tháng ước tính'>
                {outlet.expectedMonthly != null ? outlet.expectedMonthly.toLocaleString('vi-VN') : '—'}
            </Descriptions.Item>
            <Descriptions.Item label='Ngày tiếp cận'>{fmtDate(outlet.firstSeenDate)}</Descriptions.Item>
            <Descriptions.Item label='Đối thủ đang bán' span={2}>{outlet.competitors || '—'}</Descriptions.Item>
            <Descriptions.Item label='Lý do từ chối' span={2}>{outlet.rejectReason || '—'}</Descriptions.Item>
            <Descriptions.Item label='Ghi chú' span={2}>{outlet.note || '—'}</Descriptions.Item>
            <Descriptions.Item label='Đại lý cha'>{outlet.parentOutletId || '—'}</Descriptions.Item>
            <Descriptions.Item label='Ngày tạo'>{fmtDateTime(outlet.createdAt)}</Descriptions.Item>
            <Descriptions.Item label='Người tạo'>{outlet.createdByUserId ? `#${outlet.createdByUserId}` : '—'}</Descriptions.Item>
            <Descriptions.Item label='Cập nhật gần nhất'>{fmtDateTime(outlet.updatedAt)}</Descriptions.Item>
        </Descriptions>
    )
}
